module.exports = Cookies;


//////////////////
// WEBPACK FOOTER
// external "Cookies"
// module id = z2IG
// module chunks = 8